import { render, staticRenderFns } from "./douyinLiveRooms.vue?vue&type=template&id=1590e0c6"
import script from "./douyinLiveRooms.vue?vue&type=script&lang=js"
export * from "./douyinLiveRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports